export function getFileType(filename) {
	filename = filename.split('?').pop();
	if (/\.docx?$/i.test(filename)) {
		return 'word';
	}
	else if (/\.pptx?$/i.test(filename)) {
		return 'ppt';
	}
	else if (/\.pdf?$/i.test(filename)) {
		return 'pdf';
	}
	else if (/\.(zip|rar)?$/i.test(filename)) {
		return 'zip';
	}
	return null;
}



// WEBPACK FOOTER //
// ./lib/helpers/getFileType.js